<template>
  <div class="content">
    <p class="time_str">{{ update ? '刚刚' : timeShow }}</p>
    <ul>
      <li v-for="(item, i) in list" class="data" :key="i">
        <span>{{item.liftName}}</span>
        <div class="image_box">
          <a class="increase" :class="visited.indexOf(item.imageInfos[0].imageId) !== -1 ? 'is_seen' : ''" @click="showImage(item)">+{{item.num}}</a>
        </div>
      </li>
    </ul>
    <el-dialog
      :visible.sync="visible"
      width="900px"
      append-to-body>
      <p slot="title" class="pic_shot_title">流量截图</p>
      <div class="dialog_content">
        <div class="info_box" v-for="(item, i) in screenShots">
          <div class="box">
            <div class="dialog_header">
              截图{{i+1}}
            </div>
            <div class="dialog_img">
              <img @click="openImg(item)" :src="item.imageUrl"/>
            </div>
          </div>
          <div class="box">
            <div class="dialog_header">
              数据
            </div>
            <div class="dialog_info">
              <div class="tips">
                {{item.orderName|| '--'}}
              </div>
              <div class="num_box">
                <div class="num">总人数：{{item.num||0}}人</div>
                <div class="num">可识别标签：{{item.imageHpLabel?item.imageHpLabel.length:0}}人</div>
              </div>
              <div class="num_tips">注意：可识别标签≤总人数</div>
              <div class="line" v-for="(person, num) in item.imageHpLabel">
                <span class="bold">乘客{{num+1}}：</span>
                <span>{{person.sex?person.sex.labelName:''}}{{person.age?'-'+person.age.labelName:''}}{{person.clothStyle?'-'+person.clothStyle.labelName:''}}{{person.peopleType?'-'+person.peopleType.labelName:''}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="p_footer">
        <el-button size="mini" @click="visible=false" class="btn">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "DataShow",
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    time: {
      type: [Number, String],
      required: true,
    },
    update: {
      type: Boolean,
      required: true,
    }
  },
  data () {
    return {
      visited: [], // 记录查看过的流量截图ID
      visible: false,
      screenShots: [] // 智能屏流量抓图数据
    }
  },
  computed: {
    timeShow() {
      const tm = new Date(Number(this.time) * 1000)
      let hour = tm.getHours()
      let min = tm.getMinutes()
      let sec = tm.getSeconds()
      if (min < 10) {
        min = '0' + min
      }
      if (sec < 10) {
        sec = '0' + sec
      }
      return hour + ':' + min + ':' + sec
    }
  },
  methods: {
    // 查看流量抓图详情
    showImage(t) {
      console.log('flow track details:', t)
      // 图片不为空再存储
      if(t.imageInfos && t.imageInfos[0].imageId) {
        this.visited.push(t.imageInfos[0].imageId)
      }
      this.screenShots = t.imageInfos
      this.$nextTick(() => {
        this.visible = true
      })
    },
    openImg(m) {
      window.open(m.imageUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__body {
    border-top: 1px solid #E9E9E9;
    border-bottom: 1px solid #E9E9E9;
  }
  ::v-deep .el-dialog__footer {
    padding: 15px;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  .content {
    padding: 10px;
    font-size: 12px;
    height: 100%;
    ::v-deep .el-image {
      .el-icon-circle-close {
        color: #fff;
      }
    }
    .time_str {
      height: 30px;
      line-height: 30px;
      font-weight:600;
      color:rgba(40,39,41,1);
    }
    ul {
      height: calc(100% - 30px);
      overflow-y: auto;
      overflow-x: hidden;
    }
    .data {
      height: 26px;
      line-height: 26px;
      padding-left: 15px;
      color: #666666;
      .image_box {
        float: right;
        position: relative;
        .image {
          width: 20px;
          height: 20px;
          position: absolute;
          ::v-deep .el-image__preview {
            opacity: 0;
          }
        }
      }
      .increase {
        color: #421EEF;
        float: right;
        cursor: pointer;
        text-decoration:underline;
      }
      .is_seen {
        color:rgba(173,156,255,1);
      }
    }
  }
  .pic_shot_title {
    color: #282729;
    font-size: 18px;
    font-weight: bold;
    line-height: 25px;
    text-align: center;
  }
  .dialog_content {
    overflow-y: auto;
    padding: 30px 50px;
    max-height: 500px;
    .info_box {
      display: flex;
      justify-content: center;
      align-items: center;
      &:not(:last-child) {
        margin-bottom: 20px;
      }
      .box {
        flex-shrink: 0;
        width: 380px;
        border-left: 1px solid #E9E9E9;
        border-top: 1px solid #E9E9E9;
        border-bottom: 1px solid #E9E9E9;
        &:last-child {
          border-right: 1px solid #E9E9E9;
        }
        .dialog_header {
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #F5F5F5;
          border-bottom: 1px solid #E9E9E9;
          font-size: 16px;
          font-weight: 500;
          color: #282729;
        }
        .dialog_img {
          height: 390px;
          background: #000000;
          img {
            height: 100%;
            margin: 0 auto;
            display: block;
            cursor: pointer;
          }
        }
        .dialog_info {
          height: 390px;
          padding: 20px;
          border-top: 0;
          overflow-y: auto;
          .tips {
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: rgba(255, 57, 115, 0.1);
            font-size: 14px;
            font-weight: 600;
            color: #282729;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          .num_box {
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-weight: 600;
            color: #282729;
            border-left: 1px solid #E9E9E9;
            .num {
              float: left;
              width: 50%;
              text-align: center;
              border-right: 1px solid #E9E9E9;
            }
          }
          .num_tips {
            height: 30px;
            line-height: 30px;
            text-align: center;
            border: 1px solid #E9E9E9;
            font-size: 12px;
            font-weight: 400;
            color: #999999;
          }
          .line {
            line-height: 20px;
            margin-top: 15px;
            overflow: hidden;
            .bold {
              display: inline-block;
              width: 60px;
              font-weight: 500;
              color: #282729;
            }
          }
        }
      }
    }
  }
  .p_footer {
    text-align: center;
    .btn {
      width: 120px;
    }
  }
</style>
